import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from "react-helmet";

const NotFound = () => (
	<div className="cont404" >
		<Helmet>
			<title>ИРМ-страница не найдена</title>
		</Helmet>
    <p>Страница, которую вы запрашивайте не найдена.</p>
    <p>Возможно, вы ошиблись в написании адреса.</p>
    <Link to="/">Главная страница</Link>
  </div>
)

export default NotFound;


// WEBPACK FOOTER //
// ./src/routes/notfound/index.js